import api from '__jsVueApi';

export default {
	async loadListOfDeals({ state, commit }) {
		commit('main/setLoad', true, { root: true });
		let pageSize = 12;
		await axios
			.get(api.admin.deals.get, {
				params: {
					status:           (state.status !== 'all') ? (state.status) : (null),
					page:             state.page,
					page_size:        pageSize
				}
			})
			.then(response => {
				commit('setListOfDeals', response.data.results);
				commit('setPages', Math.ceil(response.data.count / pageSize));
			})
			.catch(err => {
				throw new Error(err);
			});
		commit('main/setLoad', false, { root: true });
	},
};
